<!--
 * @FileDescription: 仓库（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-30（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div>
        <div class="warehouse-ul">
            <cardTem ref="cardTem" :width="494" :height="280" :isDelete="false">
                <div class="card-tem">
                    <img src="@/assets/image/warehouse_img@2x.png" class="cardtem-img"/>
                    <div class="cardtem-add" @click="onAddWare(1)" v-has="'library_warehouse_add'">
                        <img src="@/assets/image/add_address@2x.png"/>
                        <span>新增仓库</span>
                    </div>
                    <!--<span>点击上方按钮，新增仓库</span>-->
                </div>
            </cardTem>
            <template v-for="(item,index) in storageList">
                <cardTem ref="cardTem" :index="index"  :id="item.id" @onDelete="onDelete" :width="494" :height="280" :key="item.id">
                    <div class="warehouse-li-title">{{item.storageName}}</div>
                    <div class="warehouse-li">
                        <img :src="item.storageResourceUrl" class="warehouse-li-img" v-if="!isEmpty(item.storageResourceUrl)"/>
                        <img src="@/assets/image/default-img1.png" class="warehouse-li-img" v-else/>
                        <div class="warehouse-li-center">
                                <span>
                                    <img src="@/assets/image/zhanghao@2x.png"/>
                                    <span>店长</span>
                                </span>
                            <span>
                                    <img src="@/assets/image/dianhua1@2x.png"/>
                                    <span>联系电话</span>
                                </span>
                            <span>
                                    <img src="@/assets/image/zhuangtai@2x.png"/>
                                    <span>仓库地址</span>
                                </span>
                        </div>
                        <div class="warehouse-li-right">
                            <span>{{item.contactName}}</span>
                            <span>{{item.contactMobile}}</span>
                            <span>{{item.storageAddress}}</span>
                        </div>
                    </div>
                    <div class="warehouse-li-btn">
                        <span @click="clickWarehouse(item)" v-has="'library_warehouse_operation'">库位管理</span>
                        <span  @click="onAddWare(2,item)" v-has="'library_warehouse_edit'">编辑</span>
                    </div>
                </cardTem>
            </template>
        </div>
        <v-warehouseModel ref="warehouseModel"   @onPageList="onPageList"></v-warehouseModel>
    </div>
</template>
<script>
import {storageList,storageDelete,getListOther} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import cardTem from '@/components/card-temp1'
import warehouseModel from './model/warehouseModel'
export default {
    mixins:[mixins],
    data(){
        return{
            storageList:[]
        }
    },
    watch: {
        pageList(){
            if(!this.isEmpty(this.pageList.result)){
                this.pagination.current = this.pageList.result.current
                this.pagination.total = this.pageList.result.total
                this.pagination.pageSize = this.pageList.result.size
                this.pages = this.pageList.result.pages
                this.storageList = this.pageList.result.records
                this.$store.state.isLoding = false
            }
        }
    },
    mounted () {
        this.getList()
    },
    created () {

    },
    components: {
        cardTem,
        'v-warehouseModel':warehouseModel,

    },
    methods: {
        getList(){
            this.$store.state.isLoding = true
            this.getPageListOther('/storage/api/storage/pageListStorage?companyStoreId='+this.$store.state.shopId,
                    {
                        pageNo:this.pagination.current,
                        pageSize:this.pagination.pageSize,
                    },{
                        'Content-Type':'application/json'
                    })
        },
        /**
         * @description: 删除回调（方法描述）
         */
        onDelete(index,id){
            let headers = {
                'Content-Type':'application/x-www-form-urlencoded'
            }
            storageDelete({},headers,{
                id:id,
                companyStoreId:this.$store.state.shopId,
            }).then(res => {
                if (res.success) {
                    this.getList()
                    this.$message.success(res.logMessage)
                }else{
                    this.$message.warn(res.logMessage)
                }
            })
        },
        onAddWare(index,item){
            this.$refs.warehouseModel.onOpen(index,item)
        },
        clickWarehouse(item){
            this.$refs.warehouseModel.onOpen1(item)
        },
        /**
         * @description: 添加或编辑仓库回调（方法描述）
         */
        onPageList(){
            this.getList()
        },

    },

}
</script>
<style scoped lang="scss">
    .warehouse-ul{
        display: flex;
        flex-wrap: wrap;
        padding: 30px 0 0;
        .card-tem{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            color: #AAAAAA;
            .cardtem-img{
                width: 170px;
                height: 140px;
            }
            .cardtem-add{
                cursor: pointer;
                margin-top: 10px;
                color: var(--co);
                font-size: 14px;
                margin-bottom: 14px;
                img{
                    width: 50px;
                    height: 50px;
                    margin-right: 16px;
                    object-fit: cover;
                }
            }
        }
        .warehouse-li-title{
            color: #333333;
            font-size: 16px;
            font-weight: 700;
            padding: 58px 0 20px 43px;
        }
        .warehouse-li{
            display: flex;
            padding-left: 43px;
            .warehouse-li-img{
                width: 84px;
                height: 84px;
                border-radius:6px ;
                object-fit: cover;
            }
            .warehouse-li-center{
                display: flex;
                flex-direction: column;
                padding-left: 23px;
                span{
                    padding-bottom: 10px;
                    color: #AAAAAA;
                    img{
                        width: 12px;
                        margin-right: 8px;
                        object-fit: cover;
                    }
                }
                span:last-child{
                    padding-bottom: 0;
                }
            }
            .warehouse-li-right{
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                span{
                    padding-bottom: 10px;
                }
                span:last-child{
                    padding-bottom: 0;
                }
            }
        }
        .warehouse-li-btn{
            display: flex;
            justify-content: flex-end;
            padding-right: 30px;
            padding-top: 40px;
            color: #387BFC;
            span{
                cursor: pointer;
                margin-left: 30px;
            }
        }
    }
</style>
